import React, { useEffect, useRef } from 'react';
import { ItemType } from '@openai/realtime-api-beta/dist/lib/client.js';
import './InlineTranscript.scss';

interface InlineTranscriptProps {
  items: ItemType[];
  isVisible: boolean;
}

const InlineTranscript: React.FC<InlineTranscriptProps> = ({ items, isVisible }) => {
  const scrollRef = useRef<HTMLDivElement>(null);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    if (scrollRef.current && isVisible) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [items, isVisible]);

  // Filter items to show only user and assistant messages with content
  const conversationItems = items.filter(item => {
    if (item.role === 'user' || item.role === 'assistant') {
      // Check if item has status property before accessing it
      if ('status' in item && item.status === 'completed') {
        return item.formatted?.transcript || item.formatted?.text;
      }
    }
    return false;
  });

  if (!isVisible || conversationItems.length === 0) {
    return null;
  }

  return (
    <div className="inline-transcript">
      <div className="transcript-header">
        <h3>Live Conversation</h3>
      </div>
      <div className="transcript-messages" ref={scrollRef}>
        {conversationItems.map((item, index) => (
          <div key={item.id || index} className={`message-item ${item.role}`}>
            <div className="message-speaker">
              {item.role === 'user' ? 'You' : 'Assistant'}
            </div>
            <div className="message-content">
              {item.formatted?.transcript || item.formatted?.text || ''}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InlineTranscript;
